module.exports = __webpack_public_path__ + "static/media/60.77898648.svg";